import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMoneyBill } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment';
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";

import AttendanceAddForm from '../components/attendance/add.js';
import Box from '../components/ui/Box.js';
import AttendanceView from '../components/attendance/view.js';

const AttendancePage = (props) => {
	
	const [addInterfaceOpen, setAddInterfaceOpen] = useState(false);
	const [date, setDate] = useState(new Date());
	const [key, setKey] = useState(0);
	
	const addItem = (e) => {
		setAddInterfaceOpen(true);
	}

	const closeAddInterface = (e) => {
		setAddInterfaceOpen(false);
	}
	
	const onSheetSubmitted = (e) => {
		closeAddInterface(e);
		// Refresh
		console.log("sheetSubmitted");
		setKey(key+1);
	}
	
	const onDateChange = (d) => { 
		setDate(d);
	}
	
	const offsetDate = (i) => {
		console.log(date);
		let m = moment(date);
		console.log(m);
		m = m.add(i, 'day');
		setDate(m.toDate());
	}
	
	
	
	return <div>
		<h2>Attendance <Link to={"/payroll"} title="Payroll"><FontAwesomeIcon icon={faMoneyBill}/></Link></h2>
		<button className="block plus" title="Add an attendance record" onClick={addItem}>
			<FontAwesomeIcon icon={faPlus}/>
		</button>
		<Box modal={true} isOpen={addInterfaceOpen} onRequestClose={closeAddInterface} title="Attendance sheet">
			<AttendanceAddForm date={date} onAdded={onSheetSubmitted} />
		</Box>
		<br />
		<button className="block ish" onClick={offsetDate.bind(this, -1)}>Previous</button>
		<DatePicker
			className="date"
			selected={date}
			onChange={onDateChange}
		/>
		<button className="block ish" onClick={offsetDate.bind(this, +1)}>Next</button>

		<AttendanceView date={date} reloadKey={key} />
	</div>;
}
export default AttendancePage;